/*
 * @Author: Src
 * @Date: 2025-03-25 15:36:07
 * @LastEditTime: 2025-05-20 17:05:49
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/labelRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import LabelList from '@/views/label/LabelList.vue';
import { AuthEnum } from '@/services/permission.service';

const labelRoutes: RouteConfig = {
  name: 'label',
  path: '/label',
  component: Main,
  redirect: {
    name: 'label.list',
  },
  meta: {
    title: '标签管理',
  },
  children: [
    {
      name: 'label.list',
      path: '/label/list',
      component: LabelList,
      props: {
        auth: [AuthEnum.标签列表],
      },
      meta: {
        title: '标签列表',
      },
    },
  ],
};

export default labelRoutes;
